import { Loader2 } from 'lucide-react';

import { COLORS } from '#/utils/constants';

function Loader({ color = COLORS.GRAY100, size }) {
  return <Loader2 className="animate-spin" color={color} size={size} />;
}

export default Loader;
